export const IMAGE_PATH = '/assets/images';
export const OBSERVATORY_APP_URL = 'https://observatory.cemware.com';
// export const OBSERVATORY_APP_URL = 'http://localhost:9901';

export const page = {
  // 홈
  HOME: '/',

  // 이용약관, 개인정보처리방침
  TERMS: '/terms',
  PRIVATE: '/private',

  // 인증 페이지
  LOGIN: '/auth/login',
  RESETPW: '/auth/pw-reset', // 새로 추가
  LOGOUT: '/auth/logout',
  RESEND_MAIL: '/auth/fail/resend-mail',
  TIMEOUT: '/auth/fail/timeout',
  JOIN: '/auth/join',
  JOININFO: '/auth/joininfo',
  JOINCOMPLETE: '/auth/joincomplete',
  SEARCH_PASSWORD: '/auth/sendMail',
  SEND_EMAIL: '/auth/checkMail',
  RESET_PASSWORD: '/auth/resetPassword',
  SOCITAL_LOGIN_SUCCESS: '/auth/social/success',
  NO_EMAIL: '/auth/no-email',
  EMAIL_NOT_VERIFIED: '/auth/email-not-verified',

  // 커뮤니티
  COMMUNITY: '/board/notice',
  FAQ: '/board/faq',
  TECHSUPPORT: '/board/technical_support',
  EMAILQUESTION: '/board/email-question',

  // 검색
  SEARCH: '/search',

  // 개인 페이지
  MYPAGE_USER_INFO: '/mypage/user-info',
  MYPAGE_CHANGE_PASSWORD: '/mypage/change-pw',
  MYPAGE_UNREGIST: '/mypage/unregist',
  MYPAGE_FOLLOWERS: '/mypage/followers',
  MYPAGE_FOLLOWEES: '/mypage/followees',
  MYPAGE_POINT_HISTORY: '/mypage/point-history',
  MYPAGE_CHARGE_POINT: '/mypage/charge-point',
  MYPAGE_CONTENTS_DOWNLOAD: '/mypage/contents-download',
  MYPAGE_CONTENTS_LIKE: '/mypage/contents-like',
  MYPAGE_CONTENTS_COMMENT: '/mypage/contents-comment',

  // 내 문서
  DOCUMENT: '/document',

  // 클래스
  CLASSES: '/classes',
  CLASS_LEARNING: '/classes/learning',
  CLASS_COMMUNITY: '/classes/community',
  CLASS_REVIEW: '/classes/review',

  ARTICLE: '/contents/details',

  // 공개 게시판
  PUBLIC_BOARD: '/public-board',

  // 도구
  TOOL_MATH2D: '/math2d',
  TOOL_SCIENCE2D: '/science2d',
  TOOL_ALGEBRA3D: '/algebra3d',
  TOOL_MATH_CUBE: '/math-cube',
  TOOL_WORKBOOK: '/workbook',
  TOOL_STEAM_AI: '/steam-ai',
  TOOL_STEAM_XR: '/steam-xr',
  TOOL_STEAM_MOLE: '/steam-mole',
  TOOL_OBSERVATORY: '/observatory',
  TOOL_FRACTOPIA: '/fractopia',
  TOOL_FIGURE3D: '/figure3d',
  TOOL_MATH3D: '/math3d',

  // 콘텐츠
  LEARNING: '/learning',
  ASSETS: '/assets',
  ASSET_STORE: '/asset-store',
  SUBSCRIPTION: '/subscription',
  CONTENTS: '/contents',
  CREATOR: '/creator',
  MORE_CONTENTS: '/more-contents',
  CLASS: '/class',
  LIBRARY: '/library',
  HISTORY: '/history',

  // 에러페이지
  ERROR404: '/errorpage/second',
  ERROR500: '/errorpage/first',

  // 블록체인 WEB3
  TOKEN_ICO: '/web3/token-ico',

  // 콘텐츠 뷰
  VIEW_CONTENTS: '/view',
  VIEW_AI: '/view-ai',
  METAVERSE_WORKBOOK_VIEWER: '/metaverse/workbook',

  // 클래스룸
  CLASS_ROOM: '/class-room',
  CLASS_ROOM_CREATE: '/class-room/create',
  CLASS_ROOM_PLAY: '/class-room/play',

  // 디지털 교과서
  DIGITAL_TEXTBOOK: '/digital-textbook',
  DIGITAL_CONTENT_EXAMPLE: '/digital-content-example',

  // api test
  API_TEST: '/api-test',

  // 대시보드
  DASHBOARD: '/dashboard',

  TUTORIAL: '/tutorial',

  // 스토어
  STORE: '/store',
  STOREPAYMENT: '/store-payment',
  STORE_ENROLL: '/store-enroll',
  NFT_DETAIL: '/nft-detail',
  STORE_MANAGEMENT_LIST: '/store-management',
  STORE_DOWNLOAD_LIST: '/store-download-list',

  // 판매 관리
  ADMIN_DASHBOARD: '/admin-dashboard',
  SALES_DASHBOARD_DETAIL: '/admin-dashboard/sales-dashboard-detail',
  SALES_LIST_DETAIL: '/admin-dashboard/sales-list-datail',
  DATE_LIST_DETAIL: '/admin-dashboard/date-list-detail',
  ADMIN_CLASSROOM: '/admin-classroom',
  ADMIN_STORE: '/admin-store',

  // ADMIN_DASHBOARD: '/',
  // SALES_DASHBOARD_DETAIL: '/',
  // SALES_LIST_DETAIL: '/',
  // DATE_LIST_DETAIL: '/',
  // ADMIN_CLASSROOM: '/',
  // ADMIN_STORE: '/',

  // 메타버스 다운로드 페이지
  DOWNLOAD_METAVERSE: '/metaverse/download',
  // 통계 도구 페이지
  STATISTICS: '/statistics',
} as const;

export const pageLocale: {
  [K in keyof typeof page]: `/:locale${typeof page[K]}`
} = {} as any;
Object.entries(page).forEach(([name, pagePath]) => {
  (pageLocale as any)[name] = `/:locale${pagePath}`;
});
